/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
//** Common Component's */
import Buttons from "../../../components/ui/button/Buttons";
/** Common Services & Data Files */
import ToastService from "../../../services/toastService/ToastService";
import { AppIcons } from "../../../data/appIcons";
/** Configuration Files */
/** RTK Query */
import {
  useAddOrganizationLocationMutation,
  useLazyGetAllOrganizationLocationQuery,
  useLazyGetOrganizationLocationByIdQuery,
  useUpdateOrganizationLocationMutation
} from "../../../app/services/organizationAPI";
import { useSelector } from "react-redux";
import FormCreator from "../../../components/finalForms/FormCreator";
import organizationAddressFormData from "./config/OrganizationAddress.data";

const AddOrganizationLocation = ({ onSidebarClose, isOpen, selectedId }) => {
  const locationRef = useRef();
  const organizationId = useSelector((state) => state.auth.user.organizationId)
  /* State*/
  const [formData, setFormData] = useState(organizationAddressFormData);
  // API'S Call
  const [getAllOrganizationLocation] = useLazyGetAllOrganizationLocationQuery();

  const [addOrganizationLocation, {
    isLoading: isAddLocationLoading,
    isSuccess: isAddLocationAdded,
    data: addLocationData
  }] = useAddOrganizationLocationMutation();

  const [updateOrganizationLocation, {
    isLoading: isupdateLocationLoading,
    isSuccess: isupdateLocationSuccess,
    data: UpdateLocationData,
  }] = useUpdateOrganizationLocationMutation();

  const [getOrganizationLocationById, {
    isFetching: isgetLocationfetching,
    isSuccess: isgetFecheddata,
    data: getLocationData,
  }] = useLazyGetOrganizationLocationByIdQuery();

  //** Funcation's */
  const handleSubmit = () => {
    let LocationData = locationRef.current.getFormData();
    // Get form data from the FormCreator component.
    if (!selectedId && LocationData) {
      const requestData = {
        ...LocationData,
        organizationId: organizationId,
        addressLine1: LocationData.addressLine1,
        addressLine2: LocationData.addressLine2,
        city: LocationData.city,
        state: LocationData.state,
        country: LocationData.country,
        isPrimary: false
      }
      addOrganizationLocation(requestData);
    }
    else if (selectedId && LocationData) {
      const DataUpdate = {
        ...LocationData,
        locationId: LocationData.locationId,
        organizationId: LocationData.organizationId,
        addressLine1: LocationData.addressLine1,
        addressLine2: LocationData.addressLine2,
        city: LocationData.city,
        state: LocationData.state,
        country: LocationData.country,
        // isPrimary: LocationData.isPrimary
      }
      updateOrganizationLocation(DataUpdate);
    }
  }

  const formReset = () => {
    const organizationAddressForm = { ...organizationAddressFormData };
    organizationAddressForm.initialState = { ...organizationAddressFormData.initialState };
    setFormData(organizationAddressForm);
  }

  const backToList = () => {
    onSidebarClose();
    formReset();
  };

  /* useEffects */
  useEffect(() => {
    if (selectedId) {
      getOrganizationLocationById(selectedId);
    }
  }, [selectedId, getOrganizationLocationById]);

  useEffect(() => {
    if (isgetFecheddata && !isgetLocationfetching && getLocationData) {
      if (getLocationData) {
        let Data = { ...formData };
        const { locationId, addressLine1, addressLine2, city, state, country, organizationId, isPrimary } = getLocationData;
        Data.initialState = {
          addressLine1,
          addressLine2,
          city,
          state,
          country,
          organizationId,
          locationId,
          isPrimary
        };
        setFormData(Data);
      }
    };
  }, [isgetFecheddata, isgetLocationfetching, getLocationData]);

  useEffect(() => {
    if (isupdateLocationSuccess && UpdateLocationData) {
      if (UpdateLocationData.errorMessage.includes("exists")) {
        ToastService.warning(UpdateLocationData.errorMessage);
        return;
      } else {
        ToastService.success(UpdateLocationData.errorMessage);
        backToList();
        getAllOrganizationLocation();
      }
    }
  }, [isupdateLocationSuccess, UpdateLocationData]);

  useEffect(() => {
    if (isAddLocationAdded && addLocationData) {
      if (addLocationData.errorMessage.includes("exists")) {
        ToastService.warning(addLocationData.errorMessage);
        return;
      }
      else {
        ToastService.success(addLocationData.errorMessage);
        backToList();
        getAllOrganizationLocation();

      }
    }
  }, [isAddLocationAdded, addLocationData]);

  return (
    <>
      <FormCreator
        config={formData} ref={locationRef} {...formData}
      />
      <div className="form-btn d-flex justify-content-end">
        <Buttons
          buttonTypeClassName="dark-btn"
          onClick={backToList}
          buttonText="Cancel"
        />
        <Buttons
          buttonTypeClassName="theme-btn ml-4"
          buttonText={selectedId ? "Update" : "Add"}
          onClick={handleSubmit}
          imagePath={AppIcons.AddIcon}
          isLoading={isAddLocationLoading || isupdateLocationLoading}
        />
      </div>
    </>
  );
};

AddOrganizationLocation.propTypes = {
  onSidebarClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  selectedId: PropTypes.number
};

export default AddOrganizationLocation;
